import { Copy, MessageCircle } from "lucide-react";
import { toast } from "sonner";

export default function BFConsentLinks({ c, msg = "Salon salvat ca înscris (nealocat)." }) {
  const copy = () => navigator.clipboard.writeText(c.url).then(() => toast.success("Link copiat")).catch(() => toast.error("Nu am putut copia"));
  return (
    <div className="bf-fo-consent" data-testid="bf-fo-consent">
      <p><b>{msg}</b> Acordul GDPR e în așteptare până îl semnează clienta{c.emailed ? ". I-am trimis linkul și pe email." : "."}</p>
      <div className="share-actions">
        <a className="st-btn st-btn--light" href={c.wa} target="_blank" rel="noopener noreferrer" data-testid="bf-fo-consent-wa"><MessageCircle size={14} /> Trimite-i linkul pe WhatsApp</a>
        <button type="button" className="st-btn st-btn--ghost" onClick={copy} data-testid="bf-fo-consent-copy"><Copy size={14} /> Copiază linkul</button>
      </div>
    </div>
  );
}
